import { useCallback } from "react";

import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { RootState } from "@/store";
import { setLastDataRefreshAt } from "@/store/slices/ui";

export function useGlobalCooldown(durationMs: number = 30_000) {
    const dispatch = useAppDispatch();
    const last = useAppSelector(
        (state: RootState) => state.ui.lastDataRefreshAt,
    );
    const disabled = last !== null;

    const trigger = useCallback(() => {
        if (disabled) return;
        dispatch(setLastDataRefreshAt(Date.now()));
        setTimeout(() => dispatch(setLastDataRefreshAt(null)), durationMs);
    }, [dispatch, durationMs, disabled]);

    return { disabled, trigger };
}
